export type FormEngineStatus = 'idle' | 'fetching' | 'hydrated' | 'submitting' | 'error';

export interface EngineState {
  status: FormEngineStatus;
  error: unknown | null;
}

export type EngineAction =
  | { type: 'FETCH_START' }
  | { type: 'FETCH_SUCCESS' }
  | { type: 'FETCH_ERROR'; error: unknown }
  | { type: 'SUBMIT_START' }
  | { type: 'SUBMIT_SUCCESS' }
  | { type: 'SUBMIT_ERROR'; error: unknown }
  | { type: 'RESET' };

export const initialEngineState: EngineState = {
  status: 'idle',
  error: null,
};

export function engineReducer(state: EngineState, action: EngineAction): EngineState {
  switch (action.type) {
    case 'FETCH_START':
      return { status: 'fetching', error: null };
    case 'FETCH_SUCCESS':
      return { status: 'hydrated', error: null };
    case 'FETCH_ERROR':
      return { status: 'error', error: action.error };
    case 'SUBMIT_START':
      return { status: 'submitting', error: null };
    case 'SUBMIT_SUCCESS':
      return { status: 'hydrated', error: null };
    case 'SUBMIT_ERROR':
      return { status: 'hydrated', error: action.error };
    case 'RESET':
      return initialEngineState;
    default: {
      const _exhaustive: never = action;
      return state;
    }
  }
}
